export default __webpack_public_path__ + "static/media/escoge_cuidador.eaf418b2.jpg";